import type {
  BaseErrorType,
  Connection,
  Connector,
  ConnectorNotConnectedErrorType,
  ConnectorNotFoundErrorType,
  ErrorType,
} from '@particle-network/connector-core';
import type { Config } from '../createConfig';

export type DisconnectReturnType = void;

export type DisconnectErrorType =
  | ConnectorNotFoundErrorType
  | ConnectorNotConnectedErrorType
  // base
  | BaseErrorType
  | ErrorType;

export type DisconnectParameters = {
  connector?: Connector;
};

export async function disconnect(config: Config, parameters: DisconnectParameters = {}): Promise<DisconnectReturnType> {
  let connectors: Connector[] | undefined;
  if (parameters.connector) {
    connectors = [parameters.connector];
  } else {
    const connections = [...config.state.connections.values()];
    connectors = connections.map((connection) => connection.connector);
  }

  const connections = config.state.connections;

  if (connectors && connectors.length) {
    for (const connector of connectors) {
      await connector.disconnect();
      connector.emitter.off('change', config._internal.events.change);
      connector.emitter.off('disconnect', config._internal.events.disconnect);
      connector.emitter.on('connect', config._internal.events.connect);

      connections.delete(connector.uid);
    }
  }

  config.setState((x) => {
    // if no connections exist, move to disconnected state
    if (connections.size === 0)
      return {
        ...x,
        connections: new Map(),
        current: null,
        status: 'disconnected',
      };

    // switch over to another connection
    const nextConnection = connections.values().next().value as Connection;
    return {
      ...x,
      connections: new Map(connections),
      current: nextConnection.connector.uid,
    };
  });

  // Set recent connector if exists
  {
    const current = config.state.current;
    if (!current) return;
    const connector = config.state.connections.get(current)?.connector;
    if (!connector) return;
    await config.storage?.setItem('recentConnectorId', connector.id);
  }
}
